import { WebsitePrimaryColor } from '@hrra/common-models';
import { definePreset, palette } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const colors = palette(WebsitePrimaryColor.CHEFS);

export const chefs = definePreset(Aura, {
  semantic: {
    primary: colors,
  },
  components: {
    checkbox: {
      icon: {},
    },
    treeselect: {
      dropdown: {
        width: '2rem',
      },
      root: {
        borderRadius: '0.19rem',
        hoverBorderColor: '#949494',
        focusBorderColor: '#949494',
        color: '#333',
        placeholderColor: '#CACACA',
      },
    },
    multiselect: {
      dropdown: {
        width: '2rem',
      },
      root: {
        borderRadius: '0.19rem',
        hoverBorderColor: '#949494',
        focusBorderColor: '#949494',
        color: '#333',
        placeholderColor: '#CACACA',
      },
      option: {
        selectedColor: 'initial',
        selectedBackground: 'initial',
        selectedFocusColor: 'initial',
        selectedFocusBackground: 'initial',
      },
    },
    select: {
      dropdown: {
        width: '2rem',
      },
      root: {
        borderRadius: '0.19rem',
        hoverBorderColor: '#949494',
        focusBorderColor: '#949494',
        color: '#333',
        placeholderColor: '#CACACA',
      },
    },
  },
});
